import { atom } from "recoil"

export const AtomWork= atom({
    key:'ATOMWORK',
    default:''
})